import {
  GetCategoryForFilterPageQuery,
  GetCategoryForLandingPageQuery,
} from 'src/graphql/generated/graphql-types'

export type CategoryLandingType = NonNullable<GetCategoryForLandingPageQuery['category']>
export type CategoryLandingNavigationType = NonNullable<CategoryLandingType['navigation']>

export type CategoryType = NonNullable<GetCategoryForFilterPageQuery['category']>
export type ProductSearchType = NonNullable<CategoryType['productSearch']>
export type NavigationType = NonNullable<CategoryType['navigation']>

export type FacetGroup = ProductSearchType['facets'][0]

export { default as FilterPage } from './filter-page'
export { default as CategorySiblingsList } from './category-navigation-item-list'
